/**
 * Study Mode App - Main Dashboard
 */

import {Navigate} from 'react-router-dom';
import {ROUTES} from '../../config/constants';

export function StudyModeAppPage() {
  // Redirect to documents page as the default view
  return <Navigate to={ROUTES.STUDY_DOCUMENTS} replace />;
}

